export default __webpack_public_path__ + "static/media/sliderFull_noThemeSelected.f8910bbc.svg";